module.exports = __webpack_public_path__ + "static/img/20220527_01.5b959cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20220527_01.png
// module id = jKqi
// module chunks = 0